import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth, useTheme } from "../../App";
import { logout } from "../../services/api";
import useIsMobile from "../../hooks/useIsMobile";

export default function Header() {
  const { user, logoutUser } = useAuth();
  const { isDark, toggle }   = useTheme();
  const navigate  = useNavigate();
  const location  = useLocation();
  const isMobile  = useIsMobile();

  const handleLogout = async () => {
    try { await logout(); } catch {}
    logoutUser();
    navigate("/");
  };

  const isAuthPage = ["/login", "/signup", "/", "/reset-password"].includes(location.pathname);
  const isAdmin = user?.role === "admin" || user?.role === "collaborator";
  const homePath = isAdmin ? "/admin" : "/";

  // Computed values that depend on the current theme
  const headerBg   = isDark ? "#070b12" : "#2d8641";
  const userColor  = isDark ? "#dbe4ef" : "#222";
  const logoutBg   = isDark ? "#111827" : "#fff";
  const logoutClr  = isDark ? "#dbe4ef" : "#555";
  const toggleBg   = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.15)";

  return (
    <header style={{
      background: headerBg,
      padding: isMobile ? "0 16px" : "0 40px",
      height: isMobile ? 60 : 72,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
      position: "sticky",
      top: 0,
      zIndex: 100,
      transition: "background 0.3s",
    }}>

      {/* Left: logo + theme toggle */}
      <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 10 : 16 }}>
        <div style={{ cursor: "pointer" }} onClick={() => navigate(homePath)}>
          <img
            src={isDark ? "/images/logo-green.png" : "/images/logo-black.png"}
            alt="SPEEDiagnostix"
            style={{ height: isMobile ? 28 : 36, width: "auto" }}
          />
        </div>

        <button
          onClick={toggle}
          title={isDark ? "Switch to light mode" : "Switch to dark mode"}
          style={{
            background: toggleBg,
            border: "none",
            borderRadius: 20,
            color: "#fff",
            padding: isMobile ? "5px 10px" : "5px 12px 5px 10px",
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 5,
            letterSpacing: "0.04em",
            transition: "background 0.2s",
          }}
          onMouseEnter={e => { e.currentTarget.style.background = isDark ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.25)"; }}
          onMouseLeave={e => { e.currentTarget.style.background = toggleBg; }}
        >
          <span style={{ fontSize: isMobile ? 13 : 15 }}>{isDark ? "☀️" : "🌙"}</span>
          {!isMobile && (isDark ? "Light" : "Dark")}
        </button>
      </div>

      {/* Right: user info + logout */}
      {user && !isAuthPage && (
        <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 8 : 16 }}>
          {!isMobile && (
            <button
              type="button"
              style={{ border: "none", background: "transparent", padding: 0, fontSize: 15, color: userColor, fontWeight: 700, cursor: "pointer" }}
              onClick={() => navigate("/profile")}
              title="Open profile settings"
            >
              Logged In: {user.email || user.customerName || "user"}
            </button>
          )}
          {isAdmin && (
            <button
              style={{
                background: toggleBg, border: "1px solid rgba(255,255,255,0.25)", borderRadius: 6,
                color: "#fff", padding: isMobile ? "6px 10px" : "8px 14px",
                fontSize: isMobile ? 12 : 13, fontWeight: 700, cursor: "pointer",
              }}
              onClick={() => navigate(location.pathname === "/admin" ? "/dashboard" : "/admin")}
            >
              {location.pathname === "/admin" ? "Dashboard" : "Admin"}
            </button>
          )}
          <button
            style={{
              background: logoutBg, border: "none", borderRadius: 6,
              color: logoutClr, padding: isMobile ? "6px 12px" : "8px 16px",
              fontSize: isMobile ? 13 : 14,
              fontWeight: 600, cursor: "pointer", transition: "opacity 0.2s",
            }}
            onClick={handleLogout}
            onMouseEnter={e => { e.currentTarget.style.opacity = "0.8"; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
          >
            Log Out
          </button>
        </div>
      )}
    </header>
  );
}
